import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { TrustMemberDeathValidationResult } from '../../Models/Models/Customer/TrustMemberDeathValidationResult';

declare var IS_RUNNING_IN_APP_POOL;

export class TrustMemberDeathDetailValidationClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<Array<TrustMemberDeathValidationResult>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/TrustMemberDeathDetailValidation/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<Array<TrustMemberDeathValidationResult>, any>(url, data);
  }
}

